export default "__VITE_ASSET__097f51e7__"